/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvc25hY2stbWVzc2FnZXMvc25hY2stbWVzc2FnZS9zbmFjay1tZXNzYWdlLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvc3ZhL3dlYmFwcC1jbGsvc3JjL2FwcC9zaGFyZWQvc25hY2stbWVzc2FnZXMvc25hY2stbWVzc2FnZS9zbmFjay1tZXNzYWdlLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/shared/snack-messages/snack-message/snack-message.component.scss.shim.ngstyle.ts